import { useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import useGeolocation from "react-hook-geolocation";
import { Marker } from "react-leaflet";
import { useThrottle } from "use-throttle";

import { useMapContext } from "./MapContext";
import MapElementIcon from "./MapElementIcon";
import Button from "../Buttons/Button";
import { useMoveMapCenterTo } from "./moveMapCenterTo";
import { publicAssetPath } from "../Utils/publicAssetPath";

import { setCityWalkViewerPosition } from "../../reducers/cityWalks";

const icon = MapElementIcon(
  {
    iconStyle: {
      image: {
        url: publicAssetPath("/images/map-viewer-position.png")
      },
      width: 30,
      height: 30,
      anchor: "CENTER"
    }
  },
  { className: "map-viewer-position" }
);

const MapViewerPosition = () => {
  const geolocation = useGeolocation({
    maximumAge: 1000
  });

  const moveMapCenterTo = useMoveMapCenterTo();
  const { latitude, longitude } = useThrottle(geolocation, 500);
  const [geolocationActive, setGeolocationActive] = useState(false);

  const { mapKey } = useMapContext();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setCityWalkViewerPosition(mapKey, { latitude, longitude }));
  }, [dispatch, latitude, longitude, mapKey]);

  const handleButtonClicked = useCallback(() => {
    moveMapCenterTo(latitude, longitude);
  }, [latitude, longitude, moveMapCenterTo]);

  // Nothing to display if we've no location
  if (!latitude || !longitude) {
    if (geolocationActive) setGeolocationActive(false);
    return null;
  }

  if (!geolocationActive) {
    moveMapCenterTo(latitude, longitude);
    setGeolocationActive(true);
  }

  return (
    <>
      <Marker icon={icon} position={[latitude, longitude]} zIndexOffset={10000} />

      <Button
        className="btn rounded-circle bg-white box-shadow map-viewer-position-center-button"
        onClick={handleButtonClicked}
      >
        <img src={publicAssetPath("/images/center-map.png")} width={20} height={20} />
      </Button>
    </>
  );
};

export default MapViewerPosition;
